window.dataLayer = window.dataLayer || [];
window.gtag = function () {
  // biome-ignore lint/complexity/noArguments: required GA4 snippet that pushes the arguments object verbatim
  window.dataLayer.push(arguments);
};
gtag('js', new Date());
